<template>
    <div class="w-full h-full">
        <Header
            title="Transaction processing"
            icon="Sparkles"
        />

        <!--<WhiteBox
            title="Search for an end user - DELETE THIS AFTER HOOK UP below one"
            subText="Find a users cashback object"
        >
            <template v-slot:content>
            <div class="flex w-full justify-left items-center text-center gap-3 mb-2 item-center">
                <CustomInput class="w-full" v-model="userSearch.userId" type="text" placeholder="User id" />
                <CustomButton class="w-32" id="viewPublisherButton" text="Search" icon="Search" type="action" @click="getTransactionForAnEndUser(0,50,userSearch)" />
            </div>
            </template>
        </WhiteBox>-->

        <WhiteBox
            title="Transaction processing"
            subText="View the transactions processed by the Transaction Enrichment API"
        >
            <template v-slot:buttons>
                <CustomButton small text="Upload transactions" type="navigate" icon="Upload" @click="$router.push('/transaction-enrichment/uploads')" />
                <CustomButton v-if="showDeleteTransactionButton" small text="Delete all transactions" type="warning" icon="Upload" :requires-confirmation="true" @confirmClick="deleteTransactions()" />
                

            </template>
            <template v-slot:content>
                <div class="grid grid-cols-1 xl:grid-cols-2 gap-x-2 mt-6">
                    <SearchBar placeholderText="Search by id" @search="(val) => getTransactionFromId(val)">
                        <CustomButton small text="" type="default" icon="X" @click="getTransactions(0,50)" />
                    </SearchBar>
                    <SearchBar placeholderText="Search by user id" @search="(val) => getTransactionForAnEndUser(0,25,val)">
                        <CustomButton small text="" type="default" icon="X" @click="getTransactions(0,50)" />
                    </SearchBar>
                </div>
                <EasyDataTable
                    :headers="headersTable1"
                    :items="transactions"
                    :loading="loading"
                                        v-model:server-options="serverOptions"
                    :server-items-length="serverItemsLength"
                    :hide-footer="false"
                    :no-hover="true"
                >
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                    </template>
                    <template #item-id="transaction">
                        <div class="w-20 py-1">
                            <p style="word-break:break-all; font-size:11px;">
                                {{ transaction.id }}
                            </p>
                        </div>
                    </template>
                    <template #item-bookingDateTime="transaction">
                        <div style="font-size:11px;" class="w-24 py-1">
                            {{ niceDateTime(transaction.bookingDateTime)}}
                        </div>
                    </template>
                    <template #item-amount="transaction">
                        <CashbackPill
                            :text="(Math.round(transaction.transactionAmount.amount * 100) / 100).toFixed(2)"
                            type="FIXED"
                            :currency="transaction.transactionAmount.currency"
                        />
                    </template>
                    <template #item-retailer="transaction">
                        <div class="py-1 w-full">
                        <EnrichedMerchant v-if="transaction.enrichedCreditorData != null"
                            :logo="transaction.enrichedCreditorData.logo"
                            :name="transaction.enrichedCreditorData.merchant"
                            :website="transaction.enrichedCreditorData.website"
                            :labels="transaction.enrichedCreditorData.labels == null ? '': transaction.enrichedCreditorData.labels[0] "
                        />
                        </div>
                    </template>
                    <template #item-customerTransactionId="transaction">
                        <div class="w-28 py-1">
                            <p style="font-size:11px; word-break:break-all;">
                                {{ transaction.internalTransactionId }}
                            </p>
                        </div>
                    </template>
                    <template #item-remittanceInformationUnstructured="transaction">
                        <div class="w-64 py-1">
                            <p style="font-size:11px;">
                                {{ transaction.remittanceInformationUnstructured }}
                            </p>
                        </div>
                    </template>
                    <template #item-internalEndUserId="transaction">
                        <div class="w-28 py-1">
                            <p style="word-break:break-all; font-size:11px;">
                                {{ transaction.endUserId }}
                            </p>
                        </div>
                    </template>
                    <template #item-action="transaction">
                        <div class="w-28 py-1">
                            <div class="m-2" v-if="showDeleteTransactionButton">
                                <CustomButton :requiresConfirmation="true" confrimationModalTitle="Delete this transaction"
                                confrimationModalMessage="Confirm you would like to delete this transaction"
                                confrimationModalButtonText="Delete" small text="Delete"
                                type="warning" @confirmClick="deleteTransactionFromId(transaction.id)" />                            </div>
                        </div>
                    </template>
                    <template #empty-message>
                    <div class="flex justify-center py-4">
                        <div class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                            <p class="text-sm mr-2">No results</p>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                            </svg>
                        </div>
                    </div>
                    </template>
                    </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import SearchBar from '@/components/SearchBar.vue';
//import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import EnrichedMerchant from "@/components/EnrichedMerchant.vue";
import CashbackPill from "@/components/CashbackPill.vue";
import { DateTime } from 'luxon';

export default {
	name: "transaction-enrichment",
	components: {
        Header,
        WhiteBox,
        SearchBar,
        //CustomInput,
        CustomButton,
        EnrichedMerchant,
        CashbackPill
	},
	props:{
    },

	data() {
		return {
            showDeleteTransactionButton: localStorage.getItem('apiType') == process.env.VUE_APP_SANDBOX_API,



            serverOptions:{
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength:undefined,

            userSearch:{
                userId:""
            },

            loading:true,
            headersTable1:[
                { text: "Boogi Id", value: "id" },
                { text: "Transaction id", value: "customerTransactionId"},   
                { text: "End user Id", value: "internalEndUserId"},   
                { text: "Date created", value: "bookingDateTime" },
                { text: "Enriched data", value: "retailer"},
                { text: "Amount", value: "amount"},
                { text: "Input description", value: "remittanceInformationUnstructured"},
                { text: "Action", value: "action"},   
                
            ],
            transactions:[
            ],
        }
	},
	created(){
        this.getTransactions(0,50)

	},
	methods: {
        niceDateTime(dateObject) {
			return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATETIME_MED)
		},
        async getTransactionForAnEndUser(page,size,search){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/transaction-enrichment/user/${search}?page=${page}&size=${size}`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
                    this.transactions = object.content  
                    this.serverItemsLength = object.totalElements  
                    this.loading = false
				}else
                {
                    this.transactions = []
                    this.loading = false

                }
				
			} catch (error) {
				return;
			}

		},

        async getTransactionFromId(search){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/transaction-enrichment/transaction/${search}`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
                    var array = []
                    array.push(object)

                    this.transactions = array    
                    this.serverItemsLength = 1

                    this.loading = false
				}else
                {
                    this.transactions = []
                    this.loading = false

                }
				
			} catch (error) {
				return;
			}

		},

        async deleteTransactionFromId(search){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true
                this.transactions = []

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/transaction-enrichment/transaction/${search}`, {
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					
                    this.getTransactions(0,25)
                    this.loading = false
                }
				
			} catch (error) {
				return;
			}

		},

        async deleteTransactions(){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true
                this.transactions = []

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/transaction-enrichment/transaction/deleteAll`, {
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					
                    this.getTransactions(0,25)
                    this.loading = false
                }
				
			} catch (error) {
				return;
			}

		},


        async getTransactions(page,size){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/transaction-enrichment?page=${page}&size=${size}`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
                    this.transactions = object.content    
                    this.serverItemsLength = object.totalElements
                    this.loading = false
				}else
                {
                    this.transactions = []
                    this.loading = false

                }
				
			} catch (error) {
				return;
			}

		},

	},
	computed: {

	},
    mounted() {
        document.title = "Dashboard | Transaction enrichment";
    },
	watch: {
        serverOptions: {
            deep: true,
            handler(val){
                     this.getTransactions(val.page-1,val.rowsPerPage)
                }
    }
	}
}
</script>